<script setup lang="ts">
import type { ChipProps } from 'ui/util/ui/import';

withDefaults(
  defineProps<{
    color?: ChipProps['color'];
    size?: ChipProps['size'];
  }>(),
  {
    color: 'primary',
    size: 'md',
  },
);
</script>

<template>
  <UChip
    :color="color"
    :size="size"
    standalone
    inset
  >
    <template #content>
      <slot />
    </template>
  </UChip>
</template>
